export default __webpack_public_path__ + "static/media/brick.75c569cd.jpg";